import axiosInstance from '../../util/axiosAPI';
import { API_URL } from '../../config';

export default class NetworkService {

    getNetwork() {
        const url = `${API_URL}/api/network/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    setNetwork(params) {
        const url = `${API_URL}/api/network/`;
        return axiosInstance.post(url, params);
    }

    // VPN Methods
    getVpnStatus() {
        const url = `${API_URL}/api/network/vpn/status/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    generateWireGuardKeys() {
        const url = `${API_URL}/api/network/vpn/wireguard/generate-keys/`;
        return axiosInstance.post(url).then(response => response.data);
    }

    configureVpn(config) {
        const url = `${API_URL}/api/network/vpn/configure/`;
        return axiosInstance.post(url, config).then(response => response.data);
    }

    uploadVpnConfig(formData) {
        const url = `${API_URL}/api/network/vpn/upload/`;
        return axiosInstance.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => response.data);
    }

    toggleVpn(enabled) {
        const url = `${API_URL}/api/network/vpn/toggle/`;
        return axiosInstance.post(url, { enabled }).then(response => response.data);
    }

    disconnectVpn() {
        const url = `${API_URL}/api/network/vpn/disconnect/`;
        return axiosInstance.post(url).then(response => response.data);
    }

    // WiFi Hotspot Methods
    getWifiStatus() {
        const url = `${API_URL}/api/network/wifi/status/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    toggleWifi(enabled) {
        const url = `${API_URL}/api/network/wifi/toggle/`;
        return axiosInstance.post(url, { enabled }).then(response => response.data);
    }
}